import { shipToSelectorStyles } from "@insite/content-library/Components/ShipToSelector";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

shipToSelectorStyles.customerSelectorToolbar = {
        wrapper: {
            css: css`
                display: flex;
                border-bottom: 1px solid ${getColor("common.border")};
                padding-bottom: 10px;
                > div[class^="FormFieldStyle"] {
                    > div[class^="FormInputWrapper"] {
                        height: 100% !important;
                        > span[class^="IconWrapper"] {
                            top: 5px;
                        }
                    }
                }
            `
        },
        searchButton: {
            shape: "rectangle",
            css: css`
                margin-left: auto;
            `,
        },
        searchTextField: {
            css: css`
                flex-basis: 50%;
                min-height: 100%;
            `
        },
}